const parMillis = 30 * 1000; // 30 secs without points loss
const maxScoreMillis = 3 * 60 * 1000; // Next 3 minutes with incremental points loss
const scorePerStar = 10 * 1000; // Points awarded per star

export default function calculateScore(result) {
  const {
    timeMillis,
    starsCount
  } = result;
  const millisOverPar = Math.max(0, timeMillis - parMillis);
  const scoreForMillis = Math.max(0, maxScoreMillis - millisOverPar);
  const scoreForStars = starsCount * scorePerStar;
  const score = scoreForMillis + scoreForStars;
  return Math.round(score / 100);
}